export const DATES_PER_WINDOW = 30;

// Mantener un lienzo acotado evita que Chart.js comprima fechas largas en el borde.
export function chartWindow(groups, isTimeline, requestedPage = 0) {
  const totalPages = isTimeline ? Math.max(1, Math.ceil(groups.length / DATES_PER_WINDOW)) : 1;
  const page = Math.max(0, Math.min(requestedPage, totalPages - 1));
  const end = isTimeline ? groups.length - page * DATES_PER_WINDOW : groups.length;
  const start = isTimeline ? Math.max(0, end - DATES_PER_WINDOW) : 0;
  return { groups: groups.slice(start, end), start, end, page, totalPages };
}
